import { Dialog, DialogContent, DialogTitle, DialogTitleProps, styled, GlobalStyles } from '@mui/material';
import { useIsMultiPortfolioTenant } from '../../../common/hooks';
import { ComboSelect } from '../../../components/atoms';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../common/hooks';
import { getUserRelatedInfo } from '../../../features/auth/authSlice';
import { useState } from 'react';
import { getClientJourneyFlowType } from '../../../utils';
import { advisorConsoleActions } from '../../../features/advisorConsole';

const StyledDialog = styled(Dialog)(() => ({
    '& .MuiDialog-paper': {
        maxWidth: '600px',
        borderRadius: '50px',
        padding: '40px',
        gap: '30px',
        overflow: 'hidden',
        fontSize: '14px'
    },
    // Target menu items globally since they render in a Portal
    '& + .MuiPopover-root .MuiMenuItem-root': {
        fontSize: '14px !important',
        minHeight: 'unset',
        padding: '8px 16px'
    }
}));

const StyledDialogTitle = styled(DialogTitle)<DialogTitleProps>(() => ({
    padding: 0,
    color: 'black',
    fontSize: '14px'
}));

const StyledDialogContent = styled(DialogContent)(() => ({
    padding: 0,
    height: 'calc(30vh)',
    fontSize: '14px'
}));

export const TenantSelector = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [selectedTenant, setSelectedTenant] = useState('');
    const tenantsDict = useAppSelector((state) => state?.auth?.user?.userStatus);
    const admin_tenantListFromApi = useAppSelector((state) => state?.auth?.user?.admin_tenantList);
    let userInfo = useAppSelector((state) => state?.auth?.user);
    let formattedOptions = [];
    formattedOptions = admin_tenantListFromApi.map((tenant: { value: string; label: string }) => ({
        value: tenant.value,
        label: tenant.label,
        disabled: tenantsDict[tenant.value] ?? false
    }));
    const isMultiPortfolioTenant = useIsMultiPortfolioTenant();

    const handleTenantChange = (value: any) => {
        setSelectedTenant(value);
        const isFlow2 = getClientJourneyFlowType(value) === 'flow2';
        // Seed the flow2-aware default status filter for the newly selected tenant so the console
        // opens with the correct default (flow2/Banorte -> "Complete") on this first selection.
        dispatch(advisorConsoleActions.resetForTenantSwitch({ isFlow2, isMultiPortfolioTenant }));
        dispatch(
            getUserRelatedInfo({
                tenant: value,
                userRole: (userInfo?.zoneRoles[value] && userInfo?.zoneRoles[value]['role']) || 'advisor'
            })
        );
    };

    return (
        <>
            <GlobalStyles
                styles={{
                    '.MuiPopover-root .MuiMenu-paper .MuiMenuItem-root': {
                        fontSize: '14px !important'
                    }
                }}
            />
            <StyledDialog
                className="tenant-selector-dialog"
                sx={{ zIndex: (theme) => theme.zIndex.drawer - 1 }}
                open={true}
                onClose={() => {
                    console.log('clsing modal');
                }}
                fullWidth
            >
                <StyledDialogTitle> {t('TENANT_SELECTION_HEADER')}</StyledDialogTitle>
                <StyledDialogContent>
                    <ComboSelect
                        sx={{
                            fontSize: '14px',
                            '& .MuiSelect-select': {
                                fontSize: '14px'
                            }
                        }}
                        options={formattedOptions}
                        selectedValue={selectedTenant || ''}
                        onSelectChange={handleTenantChange}
                        size={'small'}
                        placeholder={t('TENANT_SELECTION_PLACEHOLDER')}
                    />
                </StyledDialogContent>
            </StyledDialog>
        </>
    );
};
